import ProjectSelected from "./ProjectSelected.svg";
import ProjectNotSelected from "./ProjectNotSelected.svg"

export const SidebarImages = {
    ProjectSelected,
    ProjectNotSelected
}